import { useMediaQuery, useTheme } from '@qbe/ads-core';

// TODO - remove named export
export const useBreakpoint = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const isSmallDesktop = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
  const isLargeDesktop = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });
  const isXLargeDesktop = useMediaQuery(theme.breakpoints.up('xl'), { noSsr: true });

  return {
    theme,
    isMobile,
    isSmallDesktop,
    isDesktop,
    isLargeDesktop,
    isXLargeDesktop,
  };
};

export default useBreakpoint;
